import { LoggerProvider as LogProvider, BatchLogRecordProcessor as BatchLogProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { SEMRESATTRS_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { getEnvName } from './opentelemetry';
import { COMMIT_ID } from '../constants/env';

const config: {
  url: string;
  id: string;
} = {
  url: 'https://otlp.tccc.qcloud.com',
  id: 'tccc',
};
if (location.host === 'connect.tencentcloud.com') {
  Object.assign(config, {
    url: 'https://otlp.connect.tencentcloud.com',
    id: 'tcccsg',
  });
}
const provider = new LogProvider({
  resource: new Resource({
    [SEMRESATTRS_SERVICE_NAME]: 'tccc-sdk', // 你的应用名称
    'tps.tenant.id': config.id, // 你的租户名称
  }),
});

const now = () => {
  const date = new Date();
  return `${[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')} ${[
    date.getHours(),
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(),
    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds(),
  ].join(':')}`;
};

/**
 * 1. 导出器
 *  OTLPLogExporter
 * 2. log处理器
 * (1) SimpleLogProcessor 即时上报
 * (2) BatchLogProcessor  批量上报
 */
provider.addLogRecordProcessor(
  new BatchLogProcessor(
    new OTLPLogExporter({
      url: `${config.url}/v1/logs`,
      headers: {
        'X-Tps-TenantID': config.id, // 天机阁平台约定好的头部信息，即租户信息，用于分流
      },
    }),
  ),
);

type LogLevel = 'debug' | 'warn' | 'error' | 'info';

const logger = provider.getLogger('tccc-sdk', COMMIT_ID);
const baseLog = (level: LogLevel, msg: string, fields: Partial<Record<any, any>>) => {
  logger.emit({
    severityText: level?.toLowerCase() || 'info',
    body: msg,
    attributes: {
      env_name: getEnvName(),
      ...fields.attributes,
      now: now(),
      commit: COMMIT_ID,
    },
  });
};

export const otlpLogger = {
  debug: baseLog.bind(this, 'debug'),
  warn: baseLog.bind(this, 'warn'),
  error: baseLog.bind(this, 'error'),
  info: baseLog.bind(this, 'info'),
};
